<template>
  <b-modal :id="id" size="md" button-size="sm" ref="modal" :title="prefix + title" v-model="showModalLoginModal"
    @hidden="cancelar" hide-footer>
    <b-card bg-variant="light">
      <b-form @keyup.enter="enviar">
        <lg-form-input :disabled="disabledLogin" label="Nome de Usuário:" v-model="form.username" />

        <lg-form-input label="Senha:" v-model="form.password" type="password" />
      </b-form>
      <b-row class="text-center">
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <b-button id="ConcluirAprAlmoxarif" size="sm" pill variant="success" @click="enviar">
            <b-icon icon="check-circle" />
            <b-tooltip target="ConcluirAprAlmoxarif" title="Autenticar"></b-tooltip>

          </b-button>

          <b-button id="cancelarAprAlmoxarif" class=" my-2 ml-2" size="sm" pill variant="danger" @click="cancelar">
            <b-icon icon="x-circle" />

            <b-tooltip target="cancelarAprAlmoxarif" title="Cancelar"></b-tooltip>

          </b-button>

        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>
<script>
import ResourceService from "@/core/api/ResourceService"
import { required } from "vuelidate/lib/validators"
import LgFormInput from "@/core/components/Form/LgFormInput.vue";

export default {
  beforeMount() {
    this.$pedidoService = new ResourceService("/api/pedidos")
    this.$loginService = new ResourceService("/api/sgu/usuarios")

  },
  components: {
    LgFormInput,
  },

  props: {
    disabledLogin: {
      type: Boolean,
      default: false,
    },
    isPedido: {
      type: Boolean,
      default: true,
    },

    id: String,
    tarefa: {
      type: Object,
    },
    prefix: {
      type: String,
      default: "",
    },
    login: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Autenticar",
    },
  },

  data() {
    return {
      showModalLoginModal: true,
      isAuthenticated: false,
      form: {
        username: this.login,
        password: "",
      },
    }
  },

  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },

  computed: {
    formIsValid() {
      return !this.$v.$invalid
    },
  },

  methods: {
    cancelar() {
      this.showModalLoginModal = false
      this.$emit("close")
    },

    async enviar() {
      if (!this.form.username || this.form.username == "" || (!this.form.password || this.form.password == "")) {
        this.$notify({ type: 'danger', message: "Digite o login e a senha" });
        return;
      }


      if (this.isPedido) {

        try {

          await this.$pedidoService.put(`getPessoaAutenticadaParaRetirada/${this.id}`, this.form).then(response => {
            this.isAuthenticated = true;
            this.showModalLoginModal = false;
            this.$emit("tarefaRetirada", this.tarefa);
            this.$emit("usuarioAutenticado", response.data);
            this.$emit("abrirTarefaRetirada", {});

          });

        } catch ({ response }) {
          this.$notify({ type: 'danger', message: response.data });
          return;
        }


      } else {

        try {

          await this.$loginService.put(`pessoa-autenticada`, this.form);
          this.$emit("usuarioAutenticado", this.tarefa);
        } catch ({ response }) {
          this.$notify({ type: 'danger', message: "Ocorreu um erro no processamento do Login: Senha incorreta" });
          return;
        }

      }



    },
  },
}
</script>
